import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { fetch } from 'Utils';
import { queryKey } from 'Constants';
import { Benefit, DataList, DataQueryParams } from 'Types';

const config = (options = {}) => {
	return {
		...{ keepPreviousData: false },
		...options
	};
};

export const useBenefits = <T = DataList<Benefit>>(
	{ pageSize, pageNumber = 1, keyword = '' }: DataQueryParams,
	options?: UseQueryOptions<T, any, DataList<Benefit>>
): UseQueryResult<DataList<Benefit>, unknown> => {
	return useQuery({
		queryKey: [queryKey.benefits, { pageSize, pageNumber, keyword }],
		queryFn: () => fetch.benefitList(pageSize, pageNumber, keyword),
		...config(options)
	});
};

export const useUpdateBenefits = (keyword?: string) => {
	const query = useBenefits({
		pageSize: 500,
		keyword
	});
	const benefits = query.data;

	return { ...query, benefits };
};
